import { Paper } from '@material-ui/core';
import { useTranslation } from 'react-i18next'
import { GeneralForm } from '../../formSchemas/groupSetting.form'
import { FormsContainer } from '../ordersSetting/Forms/FormsContainer'
import ListLoading from '../util/Loading';
import { useGeneralForm } from './useGeneralForm';

export interface IGeneralForms {
  dispatch:any
}

export default function GeneralForms({ dispatch }:IGeneralForms) {
  const { t } = useTranslation();
  const { 
    venues, 
    languages, 
    callGroups, 
    formData, 
    onDelete, 
    onSubmit,
    isLoading,
    setSearchText } = useGeneralForm(dispatch);

  if(!formData){
    return <Paper style={{padding:"10rem 0"}}>
      <ListLoading/>
    </Paper>
  }

  return (
    <FormsContainer profileForms={GeneralForm(t, callGroups, venues, languages, formData!!, onDelete, isLoading, setSearchText)}
      onFormSubmit={onSubmit}
      settings={{...formData , multi_ordering_enabled: formData.group_settings.multi_ordering_enabled}}
      formKey={"General-Form"}
    />
  )
}
